import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgMoreVert = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 24 24",
	xmlns: "http://www.w3.org/2000/svg",
	width: "1em",
	height: "1em",
	fill: "currentColor",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M12 20c-.55 0-1.021-.196-1.412-.587C10.196 19.021 10 18.55 10 18s.196-1.021.588-1.413C10.979 16.196 11.45 16 12 16s1.021.196 1.413.587c.391.392.587.863.587 1.413s-.196 1.021-.587 1.413C13.021 19.804 12.55 20 12 20zm0-6c-.55 0-1.021-.196-1.412-.588C10.196 13.021 10 12.55 10 12s.196-1.021.588-1.412C10.979 10.196 11.45 10 12 10s1.021.196 1.413.588c.391.391.587.862.587 1.412s-.196 1.021-.587 1.412C13.021 13.804 12.55 14 12 14zm0-6c-.55 0-1.021-.196-1.412-.588C10.196 7.021 10 6.55 10 6s.196-1.021.588-1.412C10.979 4.196 11.45 4 12 4s1.021.196 1.413.588c.391.391.587.862.587 1.412s-.196 1.021-.587 1.412C13.021 7.804 12.55 8 12 8z" })
});
export default SvgMoreVert;
